// export const SIGNIN_REQUEST = "SIGNIN_REQUEST";
// export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
// export const SIGNIN_FAILURE = "SIGNIN_FAILURE";
// export const SIGNOUT = "SIGNOUT";

// export const CREATE_REQUEST = "CREATE_REQUEST";
// export const CREATE_SUCCESS = "CREATE_SUCCESS";
// export const CREATE_FAILURE = "CREATE_FAILURE";


export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST"
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS"
export const USER_LOGIN_FAILURE = "USER_LOGIN_FAILURE"

export const USER_SIGNUP_REQUEST = "USER_SIGNUP_REQUEST"
export const USER_SIGNUP_SUCCESS = "USER_SIGNUP_SUCCESS"
export const USER_SIGNUP_FAILURE = "USER_SIGNUP_FAILURE"


export const ADD_TO_CART_REQUEST = " ADD_TO_CART_REQUEST"
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS"
export const ADD_TO_CART_FAILURE = "ADD_TO_CART_FAILURE"


export const ADD_TO_WISHLIST_REQUEST = " ADD_TO_WISHLIST_REQUEST"
export const ADD_TO_WISHLIST_SUCCESS = "ADD_TO_WISHLIST_SUCCESS"
export const ADD_TO_WISHLIST_FAILURE = "ADD_TO_WISHLIST_FAILURE"


export const GET_CART_DATA_REQUEST = " GET_CART_DATA_REQUEST"
export const GET_CART_DATA_SUCCESS = "GET_CART_DATA_SUCCESS"
export const GET_CART_DATA_FAILURE = "GET_CART_DATA_FAILURE"


export const CART_PRODUCT_DELETE_REQUEST = " CART_PRODUCT_DELETE_REQUEST"
export const CART_PRODUCT_DELETE_SUCCESS = "CART_PRODUCT_DELETE_SUCCESS"
export const CART_PRODUCT_DELETE_FAILURE = "CART_PRODUCT_DELETE_FAILURE"


export const CHECK_OUT_PAGE_REQUEST = " CHECK_OUT_PAGE_REQUEST"
export const CHECK_OUT_PAGE_SUCCESS = "CHECK_OUT_PAGE_SUCCESS"
export const CHECK_OUT_PAGE_FAILURE = "CHECK_OUT_PAGE_FAILURE"